class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);

/* Formful modal */
function FFopenModal() {
  Formful.openDialog("form_ul-J5dQNAE");
}

function FFcloseModal() {
  Formful.closeDialog("form_ul-J5dQNAE");
}

document.addEventListener('DOMContentLoaded', function () {
  const closeBtn = document.getElementById('cx-consult-success-close');
  if (closeBtn) closeBtn.addEventListener('click', FFcloseModal);
  document.addEventListener('click', function (e) {
    if (e.target && e.target.id === 'cx-consult-success-close') {
      FFcloseModal();
    }
  });
  var dialog = document.querySelector('.formful__dialog');
  if (!dialog) return;
  // Global Link Listener for #book-a-free-consult
  document.addEventListener('click', function (e) {
    const link = e.target.closest('a[href*="#book-a-free-consult"], a[href$="#book-a-free-consult"]');
    if (link) {
      e.preventDefault();
      FFopenModal();
    }
  });

  // Check if current URL contains #book-a-free-consult hash
  if (window.location.hash && window.location.hash.indexOf('book-a-free-consult') !== -1) {
    FFopenModal();
  }
  // 1. Insert title/subtitle at the top of the dialog
  dialog.insertAdjacentHTML('afterbegin', `
    <div class="cx-modal-title-wrap">
      <h3 id="cx-consult-modal-title">Book a Free Consult</h3>
      <p>Tell us about your business &amp; marketing goals.</p>
    </div>
  `);

  // 2. Find the marketing field label inside the dialog
  var label = dialog.querySelector('label[for="field-marketing"]');
  if (label) {
    label.insertAdjacentHTML('beforebegin', '<p class="field-desc">Clixscape Digital is committed to protecting and respecting your privacy, and we will only use your personal information to administer your account and to provide the products and services you requested from us. From time to time, we would like to contact you about our products and services, as well as other content that may be of interest to you.</p>');
    label.insertAdjacentHTML('afterend', '<p class="field-desc">You can unsubscribe from these communications at any time. For more information on how to unsubscribe, our Privacy Policy. By clicking submit below, you consent to allow Clixscape Digital to store and process the personal information submitted above to provide you the content requested.</p>');
  }
});
